export default {
  print(data) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/print', { data });
  },
  preview(data) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/print/preview', { data });
  },
  loadTemplates(data) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/print/templates', { data });
  },
};
